module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7fcd003c4a63163684ba889c2030b9ad.png";